<div style="position:absolute; right:0; top:0; padding:20px; z-index:1;">
	<div style="display: flex; align-items: center; justify-content: center;">
		<span *ngIf="allowCancel" (click)="cancel($event)" role="button" class="jmCloseBtn"></span>
	</div>
</div>

<!--by email-->
<ng-container *ngIf="steps[currentStep].name==='username' && frmSignup.byEmail">

	<div style="margin-bottom: 10px; margin-top: 20px;">Create a Journeys global account</div>
	<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">your <span class="gColorAccentPrimary">email</span> goes here</h1>

	<div style="display: flex; flex-direction: column;">
		<label for="txtEmail" class="form-label">Email Address</label>
		<input #txtEmail
			   [(ngModel)]="frmSignup.email"
			   id="txtEmail"
			   type="text"
			   style="margin-bottom: 10px;"
			   class="form-control gFormInput"
			   autocomplete="off"
			   autocapitalize="off"
			   maxlength="50"
			   placeholder="Enter your Email"
			   (keyup)="checkUsername($event,null)"
			   (keydown)="checkUsername($event,null)" />
	</div>
	<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
		No email? Create an account <a href="javascript:void(0);" tabindex="-1" (click)="toggleUsernameEmail()">with a username</a> instead.
	</div>

	<div *ngIf="!isWaiting" class="message" [innerHTML]="frmSignup.usernameMsg">
	</div>

	<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
		<ng-container *ngIf="!isWaiting" style="width: 100%;"><button #btnUsername type="button" id="btnUsername" class="btn btn-lg btn-primary" (click)="checkUsername($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.username !== '' || frmSignup.email !== '')?'':'disabled'">Next</button></ng-container>
		<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>
	</div>
</ng-container>
<!--by username-->
<ng-container *ngIf="steps[currentStep].name==='username' && !frmSignup.byEmail">
	<div style="margin-bottom: 10px; margin-top: 20px;">Create a Journeys global account</div>
	<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Let's make a <span class="gColorAccentPrimary">username</span>!</h1>
	<div style="display: flex; flex-direction: column;">
		<label for="txtUsername" class="form-label">Email Address</label>
		<input #txtUsername
			   [(ngModel)]="frmSignup.username"
			   style="margin-bottom: 10px;"
			   id="txtUsername"
			   type="text"
			   autocomplete="off"
			   autocapitalize="off"
			   maxlength="50"
			   placeholder="Username"
			   class="form-control gFormInput"
			   (keyup)="checkUsername($event,null)"
			   (keydown)="checkUsername($event,null)" />
	</div>
	<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
		Create an account<a href="javascript:void(0);" tabindex="-1" (click)="toggleUsernameEmail()">with your email</a> instead.
	</div>

	<div *ngIf="!isWaiting" class="message" [innerHTML]="frmSignup.usernameMsg">
	</div>

	<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
		<ng-container *ngIf="!isWaiting" style="width: 100%;"><button type="button" class="btn btn-lg btn-primary" (click)="checkUsername($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.username !== '' || frmSignup.email !== '')?'':'disabled'">Next</button></ng-container>
		<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>
	</div>

	<!--You already have an account, please <span role="button" (click)="login($event)" class="text-info">Log In</span>!-->

</ng-container>
<!--password-->
<ng-container *ngIf="steps[currentStep].name==='password'">
	<div style="margin-bottom: 10px; margin-top: 20px;">Create a Journeys global account</div>
	<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Let's keep your account <span class="gColorAccentPrimary">safe</span> and <span class="gColorAccentPrimary">secure</span></h1>

	<div style="position: relative; display: flex; flex-direction: column;">
		<label for="txtPw1" class="form-label">Password</label>
		<div style="position: relative;">
			<input #txtPw1
				   [(ngModel)]="frmSignup.pw1"
				   id="txtPw1"
				   style="width: 100%;"
				   type="password"
				   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
				   class="form-control gFormInput"
				   autocomplete="off"
				   autocapitalize="off"
				   maxlength="50"
				   placeholder="Password"
				   (keydown)="checkPassword($event,null)"
				   (focus)="checkPassword($event,null)"
				   (keyup)="checkPassword($event,null)"
				   (blur)="checkPassword($event,null)" />
			<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw1Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtPw1')"></i>
		</div>
		<div [style.display]="pw1isFocused?'':'none'" style="position: absolute; top: 72px; right: 0; width: 70%; z-index: 2;">
			<div style="z-index: 2; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #28275a; position: absolute; right: 20px; ">
				<div style="width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid white; right: -8px; transform: translateY(1px); z-index: 3; position: absolute;">
				</div>
			</div>
			<div style="border-style: solid; border-width: 1px; background-color: white; border-color: #28275a; border-radius: 8px; transform: translateY(8px); padding: 10px;">
				<div style="margin-bottom: 10px;" class="gTextBold">Password <span class="gColorAccentPrimary">Criteria</span></div>
				<ul class="gTextCaption">
					<li>Must be at least 6 characters</li>
					<li>Include 1 upper case or 1 numeric value</li>
				</ul>
				<!--Password length must be at least 6 characters <br />and <br />include 1 upper case <br />or <br />1 numeric value.-->
			</div>
		</div>
	</div>
	<div style="display: flex; flex-direction: column;">
		<label for="txtPw2" class="form-label">Re-enter Password</label>
		<div style="position: relative;">
			<input #txtPw2
				   [(ngModel)]="frmSignup.pw2"
				   id="txtPw2"
				   style="width: 100%;"
				   type="password"
				   [ngClass]="(showMinimize)?'verticalSpacing20btm':'verticalSpacing25btm'"
				   class="form-control gFormInput"
				   autocomplete="off"
				   autocapitalize="off"
				   maxlength="50"
				   placeholder="Re-enter Password"
				   (keyup)="checkPassword($event,null)"
				   (focus)="checkPassword($event,null)"
				   (keydown)="checkPassword($event,null)" />
			<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw2Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtPw2')"></i>
		</div>

	</div>
	<div class="message" [innerHTML]="frmSignup.pwMsg">
	</div>
	<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
		<ng-container *ngIf="!isWaiting" style="width: 100%;"><button #btnPwNext type="button" class="btn btn-lg btn-primary" id="btnPwNext" (click)="checkPassword($event, currentStep+1)" style="width: 100%; z-index: 1;" [ngClass]="(frmSignup.pw1.length > 0 && frmSignup.pw2.length > 0)?'':'disabled'">Next</button></ng-container>
		<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>

	</div>


</ng-container>
<!--processing-->
<ng-container *ngIf="steps[currentStep].name==='final'">
	<div *ngIf="isWaiting" style="font-size: 16px;">
		<span class="jmWidgetLoadingIcon20"></span>
	</div>

	<div *ngIf="alreadySignup">
		Sign up is already complete.
		Please <a (click)="goLogin()">login</a>.
	</div>

	<div *ngIf="!(alreadySignup)">
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Processing...</h1>

		<ng-container *ngIf="usernameTaken">
			<ng-container *ngIf="frmSignup.byEmail">
				That email is taken.Try another or <span type='button' (click)='goLogin()' class="gColorAccentPrimary">Sign in</span> instead.
			</ng-container>
			<ng-container *ngIf="!frmSignup.byEmail">
				That username is taken.Try another or <span type='button' (click)='goLogin()' class="gColorAccentPrimary">Sign in</span> instead."
			</ng-container>
		</ng-container>

		<div class="messageUnderButton" *ngIf="!usernameTaken">
			<span [innerHTML]="signupMsg"></span>
		</div>

		<button type="button" *ngIf="!doneSignup&&!isWaiting" class="btn btn-primary" style="width: 100%; margin-top: 20px;" (click)="reviewRetry();">Review & Retry</button>

	</div>
</ng-container>
